/* ------------------------------------------------------------------
   FK PRINTS - animacao que roda SEMPRE, APENAS NO RODAPE
   ------------------------------------------------------------------
   O tema adiciona a classe "animated" quando o elemento entra na tela
   pela primeira vez e nunca mais tira - por isso a animacao so
   acontecia uma vez por visita.

   Este script devolve o efeito, mas SO no rodape (<footer class="footer">).
   Versao anterior pegava todas as secoes (.js-animate) e ficou poluido.

   Seguro por construcao:
   - so observa o proprio <footer>, mais nada
   - try/catch: se falhar, a pagina segue normal
   - respeita quem prefere menos animacao no sistema
------------------------------------------------------------------ */
(function () {
  'use strict';

  try {
    var prefereMenosMovimento = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefereMenosMovimento || !('IntersectionObserver' in window)) return;

    function ligar() {
      var rodape = document.querySelector('footer.footer.js-animate');
      if (!rodape) return;

      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('animated');
          } else {
            entrada.target.classList.remove('animated');
          }
        });
      }, {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0
      });

      observador.observe(rodape);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ligar);
    } else {
      ligar();
    }
  } catch (e) {
    /* silencioso: nunca deve quebrar a pagina */
  }
})();
